import { createContext } from 'react';

const AnalyticsContext = createContext(null);
AnalyticsContext.displayName = 'Analytics';

export default AnalyticsContext;
